import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
export const CHECKOUT_URL = 'https://calmpaw.impultienda.ar/checkout';
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'secondary';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg',
  variant = 'primary'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-sm sm:px-9 sm:text-base' : 'px-6 py-3 text-sm';
  const styles = variant === 'primary' ? 'bg-brand-gold text-brand-deep shadow-lg shadow-[#2f3a31]/20 hover:bg-[#f0c164] hover:shadow-xl focus-visible:ring-brand-gold/50' : 'border-2 border-brand-medium bg-transparent text-brand-deep hover:bg-brand-medium/10 focus-visible:ring-brand-medium/40';
  return <a href={CHECKOUT_URL} onClick={trackCheckoutStart} className={`inline-flex items-center justify-center rounded-full font-body font-black uppercase tracking-[0.04em] transition duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 ${styles} ${sizing} ${className}`} data-id="element-1" data-mp="19aa0recdjsqg">
      {label}
    </a>;
}